module.exports = __webpack_public_path__ + "assets/img/digitalcatalog_sp.546969ae.svg";